module.exports = __webpack_public_path__ + "static/media/industries-wood-s.0205b400.jpg";